export default __webpack_public_path__ + "static/poster-ca8c40ddb82e4036ce7d083875889988.jpeg";